import { Backdrop, Dialog, IconButton, Slide } from '@mui/material'
import React from 'react'

import CloseIcon from "@mui/icons-material/Close";
import NewTeam from 'layouts/groups/new-team-form';

const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction="down" ref={ref} {...props} />;
});

const AddTeamModal = ({open, onClose}) => {
  return (
     <Dialog
      open={open}
      TransitionComponent={Transition}
      onClose={onClose}
      scroll="paper"
      fullWidth
      maxWidth="md"
      BackdropComponent={Backdrop}
      BackdropProps={{
        style: {
          backgroundColor: "rgba(0,0,0,0.5)",
          backdropFilter: "blur(4px)",
        },
      }}
      PaperProps={{
        style: {
          marginTop: "15vh",
          borderRadius: "16px",
          overflow: "auto", // ✅
          maxHeight: "90vh", // ✅
        },
      }}
    >
      <IconButton
        onClick={onClose}
        sx={{
          position: "absolute",
          right: 16,
          top: 16,
          color: "text.main",
          zIndex: 1,
        }}
      >
        <CloseIcon />
      </IconButton>
      <NewTeam />
    </Dialog>
  )
}

export default AddTeamModal